import { styled } from '@mui/material/styles';

export const Button = styled('button')(() => ({
  alignItems: 'center',
  background: 'none',
  border: 'none',
  cursor: 'pointer',
  display: 'flex',
  justifyContent: 'center',
  padding: 0,
  '&:focus': {
    outline: 'none'
  }
}));

export const ContentWrapper = styled('div', {
  shouldForwardProp: prop => prop !== 'togglerPosition'
})(({ togglerPosition }) => ({
  display: 'flex',
  flexDirection: togglerPosition === 'top' ? 'column-reverse' : 'column',
  width: '100%'
}));

export const Label = styled('span')(({ theme }) => ({
  fontWeight: theme.typography.fontWeightRegular, // same as old theme.fontWeight.normal
  marginRight: theme.spacing(0.5)
}));

export const ToggleIcon = styled('span')(() => ({
  fontSize: '2em',
  transform: 'rotate(270deg)'
}));

export const TogglerContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'flex-end',
  alignItems: 'center',
  paddingTop: theme.spacing(3) // match old spacing
}));
